export class GeoCluster {
  constructor() {}

  startCluster(elements, imgKeys, bias: number = 1) {
    var tot_diff = 0;
    var diffs = [];
    var diff;

    const env = this;

    // calculate sum of differences
    for (let i = 1; i < elements.length; i++) {
      diff = this.dist(
        elements[i][0],
        elements[i][1],
        elements[i - 1][0],
        elements[i - 1][1]
      );
      tot_diff += diff;
      diffs.push(diff);
    }

    // calculate mean diff
    var mean_diff = tot_diff / diffs.length;
    var diff_variance = 0;

    // calculate variance total
    diffs.forEach(function (diff) {
      diff_variance += Math.pow(diff - mean_diff, 2);
    });

    // derive threshold from stdev and bias
    var diff_stdev = Math.sqrt(diff_variance / diffs.length);
    var threshold = diff_stdev * bias;

    var cluster_map = [];

    const r = Math.floor(Math.random() * elements.length);

    // generate random initial cluster map
    cluster_map.push({
      centroid: elements[r],
      elements: [],
      elementsImgKey: [],
    });

    // loop elements and distribute them to clusters
    var changing = true;
    while (changing === true) {
      var new_cluster = false;
      var cluster_changed = false;

      // iterate over elements
      elements.forEach(function (e, ei) {
        var closest_dist = Infinity;
        var closest_cluster = null;

        var imgKetAtIndex = imgKeys[ei];

        // find closest cluster
        cluster_map.forEach(function (cluster, ci) {
          // distance to cluster
          let dist = env.dist(
            e[0],
            e[1],
            cluster_map[ci].centroid[0],
            cluster_map[ci].centroid[1]
          );

          if (dist < closest_dist) {
            closest_dist = dist;
            closest_cluster = ci;
          }
        });

        // is the closest distance smaller than the stddev of elements?
        if (closest_dist < threshold || closest_dist === 0) {
          // put element into existing cluster
          cluster_map[closest_cluster].elements.push(e);
          cluster_map[closest_cluster].elementsImgKey.push(imgKetAtIndex);
        } else {
          // create a new cluster with this element
          cluster_map.push({
            centroid: e,
            elements: [e],
            elementsImgKey: [imgKetAtIndex],
          });

          new_cluster = true;
        }
      });

      // delete empty clusters from cluster_map
      cluster_map = cluster_map.filter(function (cluster) {
        return cluster.elements.length > 0;
      });

      // calculate the clusters centroids and check for change
      cluster_map.forEach(function (cluster, ci) {
        var centroid = env.centroid(cluster.elements);
        if (
          centroid[0] !== cluster.centroid[0] ||
          centroid[1] !== cluster.centroid[1]
        ) {
          cluster_map[ci].centroid = centroid;
          cluster_changed = true;
        }
      });

      // loop cycle if clusters have changed
      if (!cluster_changed && !new_cluster) {
        changing = false;
      } else {
        // remove all elements from clusters and run again
        if (changing)
          cluster_map = cluster_map.map(function (cluster) {
            cluster.elements = [];
            cluster.elementsImgKey = [];
            return cluster;
          });
      }
    }

    // compress result
    return cluster_map;
  }

  dist(lat1, lon1, lat2, lon2) {
    var dlat = this.toRad(lat2 - lat1);
    var dlon = this.toRad(lon2 - lon1);
    var a =
      Math.sin(dlat / 2) * Math.sin(dlat / 2) +
      Math.sin(dlon / 2) *
        Math.sin(dlon / 2) *
        Math.cos(this.toRad(lat1)) *
        Math.cos(this.toRad(lat2));
    return (
      Math.round(2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a)) * 6371 * 100) /
      100
    );
  }

  clean(data) {
    return data.map(function (cluster) {
      return [cluster.centroid, cluster.elements];
    });
  }

  centroid(set) {
    return set
      .reduce(
        function (s, e) {
          return [s[0] + e[0], s[1] + e[1]];
        },
        [0, 0]
      )
      .map(function (e) {
        return e / set.length;
      });
  }

  toRad(n) {
    return (n * Math.PI) / 180;
  }
}

export function ConvertDMSToDD(input) {
  let parts = input.split(/[^\d\w\.]+/);
  let degrees = parts[0];
  let minutes = parts[2];
  let seconds = parts[3];
  let direction = parts[4];

  let dd =
    parseFloat(degrees) +
    parseFloat(minutes) / 60 +
    parseFloat(seconds) / (60 * 60);

  if (direction == 'S' || direction == 'W') {
    dd = dd * -1;
  } // Don't do anything for N or E
  return dd;
}
